import { useEffect, useState, useMemo } from 'react';
import { useAuth } from '../context/AuthContext';

/**
 * Lightweight hook to fetch the current user's clients (Phase A — Agency workflow).
 * Returns the list, a fast lookup map, and a loading flag. Each consumer fetches
 * once on mount — clients are tiny + change rarely so we don't bother caching.
 */
export const useClients = () => {
  const { api } = useAuth();
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    api.get('/clients')
      .then((r) => { if (!cancelled) setClients(r.data?.clients || []); })
      .catch(() => { /* fail-soft — pages still render without clients */ })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [api]);

  const byId = useMemo(() => {
    const m = {};
    for (const c of clients) m[c.id] = c;
    return m;
  }, [clients]);

  return { clients, byId, loading };
};
